import {
    ADMINISTRATOR_ROLE,
    DIGI_ROLE,
    HELPER_ROLE,
    ORGANISERS_ADMINISTRATOR_ROLE,
    ORGANIZER_ROLE,
    USER_ROLE
} from "@model";
import {TranslocoService} from "@ngneat/transloco";

export function getRoleTitle(transloco: TranslocoService, role?: string): string  {
    const roles = {
        [ORGANIZER_ROLE]: "app.common.role.organiser",
        [ADMINISTRATOR_ROLE]: "app.common.role.admin",
        [USER_ROLE]: "app.common.role.user",
        [HELPER_ROLE]: "app.common.role.helper",
        [DIGI_ROLE]: "app.common.role.digi",
        [ORGANISERS_ADMINISTRATOR_ROLE]: "app.common.role.organisersAdministrator"
    };
    const key: string | undefined = role ? roles[role] : undefined;
    return key ? transloco.translate(key) : "-";
}